import { Controller } from "@hotwired/stimulus"
import Stimulus from "../../shared/utils/stimulus"
import { toggleClass } from "@oddcamp/js-utils/src/attribute"

class NewFixedTermAccount extends Controller {
  static targets = [
    `occupation`,
    `occupationSpecification`,
    `requiredField`,
    `employmentField`,
    `fundsOwnerInput`,
    `fundsOwnerInputField`,
    `fundsOwnerDependant`,
    `submitButton`,
  ]

  static values = { fundsOwnerError: String }

  connect() {
    window.setTimeout(this.fundsOwnerChange, 50)
  }

  fundsOwnerChange = () => {
    const checkedEl = this.fundsOwnerInputTargets.find((i) => i.checked)
    const isNotOwner = checkedEl && checkedEl.value == `false` ? true : false

    toggleClass(this.fundsOwnerDependantTargets, `hidden`, isNotOwner)
    this.submitButtonTarget.disabled = isNotOwner

    this.fundsOwnerInputFieldTarget.dispatchEvent(
      new CustomEvent(`setError`, {
        detail: { message: isNotOwner ? this.fundsOwnerErrorValue : `` },
      })
    )
  }
}

Stimulus.register(`new-fixed-term-account`, NewFixedTermAccount)

class OpenFixedTermAccount extends Controller {
  static targets = [
    `submitButton`,
    `investedAmountInput`,
    `periodLengthMonthsInput`,
  ]

  connect() {
    // Add event listener for input changes
    this.investedAmountInputTarget.addEventListener(
      `input`,
      this.handleAmountChange
    )
    this.periodLengthMonthsInputTarget.addEventListener(
      `change`,
      this.handlePeriodChange
    )
    // Check initial state
    this.handleAmountChange()
    this.handlePeriodChange()
  }

  disconnect() {
    // Clean up event listeners
    this.investedAmountInputTarget.removeEventListener(
      `input`,
      this.handleAmountChange
    )
    this.periodLengthMonthsInputTarget.removeEventListener(
      `change`,
      this.handlePeriodChange
    )
  }

  handleAmountChange = () => {
    this.updateSubmitButton()
  }

  handlePeriodChange = () => {
    this.updateSubmitButton()
  }

  updateSubmitButton = () => {
    const amount = this.investedAmountInputTarget.value.trim()
    const period = this.periodLengthMonthsInputTarget.value.trim()

    const amountEmpty = !amount || amount === `` || parseFloat(amount) === 0
    const periodEmpty = !period || period === `` || parseFloat(period) === 0

    this.submitButtonTarget.disabled = amountEmpty || periodEmpty
  }
}

Stimulus.register(`open-fixed-term-account`, OpenFixedTermAccount)
